module.exports = __webpack_public_path__ + "static/media/pic1.fc0569fe.jpg";